import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'src/components'
import { LocalizedText } from 'src/components/intl'
import { mergeProps } from 'src/util'
import { Columns } from 'src/components/layout'
import { Icon, LockIcon } from 'src/components/icons'
import styles from './PermissionTooltip.scss'

const PermissionTooltip = ({ allowed, placement, ...props }) => (
  <Tooltip
    {...mergeProps({ popperProps: (a, b) => ({ ...a, ...b }) })(
      { className: { [styles.notAllowed]: !allowed }, popperProps: { placement } },
      props
    )}
    disabled={allowed}
  />
)

PermissionTooltip.defaultProps = {
  title: (
    <Columns align="center">
      <Icon icon={LockIcon} />
      <LocalizedText id="WEB_FORBIDDEN" />
    </Columns>
  ),
}

PermissionTooltip.propTypes = {
  allowed: PropTypes.bool,
  placement: PropTypes.string,
}

export default PermissionTooltip
